import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import PriceDisplay from "../../containers/PriceDisplay";
import { Button } from "../common";
import styles from "./styles.less";
import { changeDateToMomentFormat } from "../../helpers/dateHelpers";

class ThumbNailCustom extends React.Component {
  onShowDetailsClick = e => {
    const { onShowDetailsClick, product } = this.props;
    e.stopPropagation();
    onShowDetailsClick(product);
  };

  calculateNights = (checkin, checkout) => {
    let result = "";

    if (checkin && checkout) {
      const ciMoment = changeDateToMomentFormat(checkin, ".");
      const coMoment = changeDateToMomentFormat(checkout, ".");
      result = coMoment.diff(ciMoment, "days");
    }

    return result;
  };

  render = () => {
    const {
      titles,
      isIE,
      product,
      showClubPrices,
      MoreDetailsTitle,
      propertyType,
      isMobileView,
      showPricePerNightThumb,
      checkinDate,
      checkoutDate,
      isPromoCodeValid
    } = this.props;
    let propertyTypeName = propertyType || "Room";
    propertyTypeName = propertyTypeName === "Apartment" ? "" : propertyTypeName;
    const numberOfNights = this.calculateNights(checkinDate, checkoutDate);

    return (
      <div className={cx(styles.roomBoxWrapper)}>
        <div className={styles.roomBoxUpperSection}>
          <div
            clamp={1}
            className={cx(styles.roomBoxTitle, {
              [styles.ieIsShit]: isIE,
              [styles.mobileView]: isMobileView
            })}
          >
            {product.name}
          </div>
          <div
            className={cx(styles.roomBoxMoreDetails, {
              [styles.mobileView]: isMobileView
            })}
            onClick={this.onShowDetailsClick}
            onKeyDown={this.onShowDetailsClick}
            role="button"
            tabIndex="0"
          >
            {MoreDetailsTitle}
          </div>
          <div
            className={cx(styles.roomBoxPrice, {
              [styles.mobileView]: isMobileView
            })}
          >
            {titles.StartingFrom}
            {product.oldPrice > 0 &&
              product.oldPrice > product.lowestPrice && (
                <span className={styles.roomBoxPriceOld}>
                  <PriceDisplay
                    price={product.oldPrice}
                    currentCurrencyCode={product.currencyCode}
                    fallBackCurrencySymbol={product.currency}
                  >
                    {price => price}
                  </PriceDisplay>
                </span>
              )}
            <span className={styles.roomBoxPriceNew}>
              <PriceDisplay
                price={product.lowestPrice}
                currentCurrencyCode={product.currencyCode}
                fallBackCurrencySymbol={product.currency}
                showPricePerNightThumb={showPricePerNightThumb}
              >
                {price => price}
              </PriceDisplay>
            </span>
          </div>
        </div>
        {showPricePerNightThumb && (
          <div className={styles.roomBoxPerNight}>* {titles.PerNight}</div>
        )}
        {!showPricePerNightThumb &&
          numberOfNights &&
          numberOfNights > 1 && (
            <div
              className={styles.roomBoxPerNight}
            >{`* ${titles.PriceForStay.replace(
              "[NumberOfNight]",
              numberOfNights
            )}`}</div>
          )}
        {/* <div className={styles.dealDescription} clamp={2}>
          {product.description}
        </div> */}
        {showClubPrices &&
          !isPromoCodeValid && (
            <div
              className={cx(styles.roomBoxClubMemeber, {
                [styles.roomBoxClubMemeberIeIsShit]: isIE
              })}
            >
              <PriceDisplay
                price={product.simpleClubTotalPrice}
                currentCurrencyCode={product.currencyCode}
                fallBackCurrencySymbol={product.currency}
                showPricePerNightThumb={showPricePerNightThumb}
              >
                {price => price + " " + titles.SpecialPriceForClubMemeber}
              </PriceDisplay>
            </div>
          )}
        <Button
          className={cx(styles.roomBoxButton, {
            [styles.mobileView]: isMobileView
          })}
          title={`${titles.Select} ${propertyTypeName &&
            titles[propertyTypeName]}`}
          onClick={this.onClick}
        />
      </div>
    );
  };
}

ThumbNailCustom.propTypes = {
  titles: PropTypes.object,
  MoreDetailsTitle: PropTypes.string,
  propertyType: PropTypes.string,
  product: PropTypes.object,
  onShowDetailsClick: PropTypes.func,
  isIE: PropTypes.bool,
  showClubPrices: PropTypes.bool,
  isMobileView: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  isPromoCodeValid: PropTypes.string
};

export default ThumbNailCustom;



// WEBPACK FOOTER //
// ./src/components/ThumbNailCustom/ThumbNailCustom.js